import { Input } from "@ui";
import style from "./AffiliateLink.module.scss";
import { useGetReferralDataQuery } from "@RTKQuery/user/referrals/referrals";

export function AffiliateLink() {
    const { data } = useGetReferralDataQuery();

    return (
        <div className={style.container}>
            <p className={style.label}>Ваше партнерське посилання</p>
            <Input 
                value={data?.ref_link || ""}
                readOnly
                actions="copy"
                customStyle={{
                    width: "!max-w-full !mb-[15px]"
                }}
            />
            <p className={style.massage}>Заробляйте <span>10% з кожної оплати,</span> зробленої користувачами, яких ви запросили за вашим посиланням.</p>
        </div>
    )
}